import React, { useState, useEffect } from "react";
import { Copy } from "@carbon/icons-react";
import { CTooltip } from "@coreui/react";

const CopyToClipboard = ({
  icon: Icon = Copy,
  text = "",
  style = {},
  className = "",
  onClick = () => {},
}) => {
  const [copied, setCopied] = useState(false);
  let timeoutId;

  const handleCopy = (e) => {
    if (onClick) {
      onClick(e);
    }
    navigator.clipboard.writeText(text);
    setCopied(true);
    timeoutId = setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <CTooltip
      content={copied ? "Copied to clipboard" : "Copy to clipboard"}
      placement="top"
    >
      <Icon
        className={`small-icon clickable-icon ${className}`}
        onClick={(e) => handleCopy(e)}
        style={style}
      />
    </CTooltip>
  );
};

export default CopyToClipboard;
